import React from "react"

export function RedirectWithLocationChange({path}: {path: string}) {
	window.location.pathname = path
	return <></>
}
